<template>
  <router-view/>
</template>
<script>
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { ref, onBeforeMount } from 'vue';
import { useRouter, useRoute } from 'vue-router';

export default {
  name: "App",

  setup() {
    const route = useRoute();
    const router = useRouter();

    onBeforeMount(() => {
      const auth = getAuth();
      onAuthStateChanged(auth, (user) => {
        if (!user) {
          router.replace("/login");
        } else if( route.path === "/login" || route.path === "/register") {
          router.replace("/");
        }
      });
    })
  }
}
</script>
